<template>
    <div class="content-group border-top-lg border-top-primary">
        <div class="page-header page-header-default page-header-xs"
             style="border-left: 1px solid #ddd; border-right: 1px solid #ddd;">
            <div class="page-header-content">
                <div v-if="isBlogOfLinks" class="page-title">
                    <h5><span class="text-semibold"><router-link to="/"><span class="hidden-xs"><img src="/assets/img/logo.png" height="18px"/> - </span>Small pieces of the Internet</router-link><small v-if="loggedIn">by {{getUser.email}} </small></span></h5>
                </div>
                <div v-else class="page-title pb-logo">
                    <h5><span class="text-semibold">
                        <router-link to="/">
                            <span class="hidden-xs"><img src="/assets/img/pb_logo.png" height="40px"/></span>
                        </router-link><small v-if="loggedIn">by {{getUser.email}} </small></span></h5>
                </div>

                <div class="heading-elements">

                    <div class="btn-group heading-btn">
                        <button class="btn btn-link btn-icon heading-btn dropdown-toggle" data-toggle="dropdown"><i
                                class="fa fa-cog hidden-xs"></i><span class="visible-xs">Open menu</span></button>

                        <ul class="dropdown-menu dropdown-menu-right">
                            <li v-if="loggedIn"><a href="#" @click.prevent="updateMode"><i class="fa fa-gamepad pull-right"></i> Mode | <b>{{mode}}</b></a></li>
                            <li v-if="isBlogOfLinks"><a href="https://andreihirvi.com" target="_blank"><i class="fas fa-book pull-right"></i> Blog</a></li>
                            <li v-else><a href="https://www.andrew.ooo" target="_blank"><i class="fas fa-link pull-right"></i> Blog of links</a></li>
                            <li><router-link to="/about"><i class="fa fa-user pull-right"></i> About me</router-link></li>
                            <li v-if="!loggedIn"><a href="#" @click.prevent="toggleModal"><i class="fas fa-sign-in-alt pull-right"></i> Login</a></li>
                            <li v-if="loggedIn"><a href="#" @click.prevent="logout"><i class="fas fa-sign-out-alt pull-right"></i> Logout</a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <login-modal :showModal="showModal" :toggleModal="toggleModal">

        </login-modal>
    </div>
</template>
<script>
    import LoginModal from "./LoginModal.vue"
    import { mapActions, mapGetters, mapState } from 'vuex'
    import firebase from 'firebase'
    import swal from 'sweetalert2'

    export default {
        components: {LoginModal},
        computed: {
            ...mapState(['mode', 'isBlogOfLinks']),
            ...mapGetters(['getUser', 'loggedIn'])
        },
        data () {
            return {
                showModal: false
            }
        },
        methods: {
            ...mapActions(['changeMode']),
            updateMode () {
              let mode = (this.mode === 'public' ? 'private' : 'public');
              this.changeMode({mode: mode});
            },
            toggleModal() {
                this.showModal = !this.showModal;
            },
            logout() {
                firebase.auth().signOut().then(function() {
                    swal(
                        'Waiting back!',
                        'You have logged out',
                        'success')
                });
            }
        }
    }
</script>

<style>
    @media (min-width:769px) {
        .pb-logo {
            padding-top: 12px!important;
            padding-bottom: 12px!important;
        }
    }
</style>



// WEBPACK FOOTER //
// Header.vue?14e9dded